import { Swords, ArrowRight, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Challenge } from '@/types/game';

interface ChallengesListProps {
  challenges: Challenge[];
  userId: string;
}

export function ChallengesList({ challenges, userId }: ChallengesListProps) {
  const navigate = useNavigate();

  if (challenges.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground">
        No challenges yet. Beat someone's run to send a challenge!
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {challenges.map((challenge) => {
        const isSent = challenge.from_user_id === userId;
        const statusColors: Record<string, string> = {
          pending: 'text-warning',
          accepted: 'text-info',
          completed: 'text-primary',
          declined: 'text-muted-foreground',
          expired: 'text-muted-foreground',
        };

        return (
          <div key={challenge.id} className="game-card">
            <div className="flex items-center gap-4">
              <div className={`p-2 rounded-full ${isSent ? 'bg-primary/20' : 'bg-accent/20'}`}>
                {isSent ? (
                  <ArrowRight className="w-4 h-4 text-primary" />
                ) : (
                  <ArrowLeft className="w-4 h-4 text-accent" />
                )}
              </div>
              <div className="flex-1">
                <p className="font-semibold">
                  {isSent ? 'Challenge sent' : 'Challenge received'}
                </p>
                <p className="text-sm text-muted-foreground">
                  {challenge.match?.start_title} → {challenge.match?.target_title}
                </p>
              </div>
              <div className="text-right">
                <span className={`text-sm font-medium ${statusColors[challenge.status]}`}>
                  {challenge.status.charAt(0).toUpperCase() + challenge.status.slice(1)}
                </span>
              </div>
              {challenge.status === 'pending' && !isSent && (
                <Button
                  size="sm"
                  onClick={() => navigate(`/play?challenge=${challenge.id}`)}
                  className="gap-1"
                >
                  <Swords className="w-3 h-3" />
                  Accept
                </Button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}